module.exports = __webpack_public_path__ + "app/themes/vwfs/sme-price-list-assets/img/my-fleet-pro.6c63b2d0.svg";